<template>
   <div class="gradient" :style="{ width: width + 'vw' }">
  </div>
</template>

<script>

export default {
  name: 'gradient',
  props:{
    width: String,
  }
}
</script>

<style scoped>

.gradient
{
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  background-image: url('../assets/shade.png');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  display: none;
}

</style>
